export default __webpack_public_path__ + "static/media/bg-masthead-3-480w.69c40d13.webp";